import { ReactNode } from "react";

import { RootDispatch } from "../types";
import { Message } from "./types";
import nonce from "../../utils/nonce";

interface FlashAddAction {
  type: "flash/add";
  message: Message;
}
interface FlashExpireAction {
  type: "flash/expire";
  id: string;
}

export type Action = FlashAddAction | FlashExpireAction;

export const expire = (id: string): FlashExpireAction => ({ type: "flash/expire", id });

export const flash = (
  body: ReactNode,
  level: "info" | "warn" | "error" = "info",
  durationSeconds = 5
) => async (dispatch: RootDispatch) => {
  const message = {
    id: nonce(),
    body,
    level
  };

  dispatch({ type: "flash/add", message });
  setTimeout(() => dispatch({ type: "flash/expire", id: message.id }), durationSeconds * 1000);
};

export default flash;
